// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button_wrapper__ng7gR"};